import React from 'react';
import { Select, Text, Flex, Box } from '@scale/scaleui-radix';
import { VALID_DURATION_DAYS } from './projectInviteConstants';

type ExpirationDurationSelectorProps = {
  /**
   * The current duration value in days (as string)
   */
  value: string;
  /**
   * Callback when the duration changes
   */
  onChange: (value: string) => void;
  /**
   * Whether the selector is disabled
   */
  disabled?: boolean;
  /**
   * Whether to show the label and description
   */
  showLabel?: boolean;
  /**
   * Custom className for the trigger
   */
  className?: string;
};

/**
 * Generates Select.Item components for the duration options
 */
const generateDurationOptions = (days: readonly number[]) =>
  days.map(day => (
    <Select.Item key={day} value={day.toString()}>
      {day} {day === 1 ? 'day' : 'days'}
    </Select.Item>
  ));

/**
 * Selector for invite expiration duration
 * Options are 1, 2, or 3 days
 */
export const ExpirationDurationSelector: React.FC<ExpirationDurationSelectorProps> = ({
  value,
  onChange,
  disabled = false,
  showLabel = true,
  className = 'w-full',
}) => {
  return (
    <Box>
      <Flex direction="column" gap="1">
        {showLabel && (
          <Text size="2" weight="medium">
            Invite expires in
          </Text>
        )}
        <Select.Root value={value} onValueChange={onChange} disabled={disabled}>
          <Select.Trigger className={className} />
          <Select.Content>{generateDurationOptions(VALID_DURATION_DAYS)}</Select.Content>
        </Select.Root>
        {showLabel && (
          <Text size="2" weight="light" color="neutral">
            Invites will be sent out immediately, make sure you're sending invitations to the right
            CBs.
          </Text>
        )}
      </Flex>
    </Box>
  );
};
